export const ASM_COLLAPSE_COOKIE = "ASMcollapseBtn";

export interface CollapseState {
  /** Horizontal position as a percentage of the wrapper width (0–100). */
  position: number;
  state: boolean;
}

const buildCookie = (value: string): string => `${ASM_COLLAPSE_COOKIE}=${value}; path=/`;

/** Reads the persisted collapse-button position/state. Returns `null` when absent or invalid. */
export function readAsmCollapseCookie(): CollapseState | null {
  if (typeof document === "undefined") {
    return null;
  }
  const nameEQ = `${ASM_COLLAPSE_COOKIE}=`;
  const cookies = document.cookie.split(";");
  for (const raw of cookies) {
    let candidate = raw;
    while (candidate.charAt(0) === " ") {
      candidate = candidate.substring(1, candidate.length);
    }
    if (candidate.indexOf(nameEQ) === 0) {
      try {
        return JSON.parse(decodeURIComponent(candidate.substring(nameEQ.length, candidate.length)));
      } catch {
        return null;
      }
    }
  }
  return null;
}

/** Persists the collapse-button position/state using the same name/format as the legacy JS. */
export function writeAsmCollapseCookie(collapse: CollapseState): void {
  if (typeof document === "undefined") {
    return;
  }
  document.cookie = buildCookie(encodeURIComponent(JSON.stringify(collapse)));
}
